import { z } from 'zod'
import { zTableConfig } from './table'
import { zLineConfig } from './line'
import { zColumnConfig, zColumnParallelConfig, zColumnPercentConfig } from './column'
import { zBarConfig, zBarParallelConfig, zBarPercentConfig } from './bar'
import { zAreaConfig, zAreaPercentConfig } from './area'
import { zScatterConfig } from './scatter'
import { zDualAxisConfig } from './dualAxis'
import { zDonutConfig, zPieConfig, zRadarConfig } from './pie'
import { zRoseConfig, zRoseParallelConfig } from './rose'
import { zFunnelConfig } from './funnel'
import { zHeatmapConfig } from './heatmap'
import { zPivotTableConfig } from './pivotTable'
import { zBoxplotConfig } from './boxplot'
import { zHistogramConfig } from './histogram'
import {
  zRaceBarConfig,
  zRaceColumnConfig,
  zRaceDonutConfig,
  zRaceLineConfig,
  zRacePieConfig,
  zRaceScatterConfig,
} from './race'
import { zTreeMapConfig } from './treeMap'
import { zSunburstConfig } from './sunburst'
import { zCirclePackingConfig } from './circlePacking'
import { zHierarchySankeyConfig } from './hierarchySankey'
import { zSankeyConfig } from './sankey'

export type Config = z.infer<typeof zConfig>
export const zConfig = z.object({
  table: zTableConfig.nullish(),
  pivotTable: zPivotTableConfig.nullish(),

  // cartesian
  line: zLineConfig.nullish(),
  column: zColumnConfig.nullish(),
  columnParallel: zColumnParallelConfig.nullish(),
  columnPercent: zColumnPercentConfig.nullish(),
  bar: zBarConfig.nullish(),
  barParallel: zBarParallelConfig.nullish(),
  barPercent: zBarPercentConfig.nullish(),
  area: zAreaConfig.nullish(),
  areaPercent: zAreaPercentConfig.nullish(),

  scatter: zScatterConfig.nullish(),
  dualAxis: zDualAxisConfig.nullish(),

  // polar
  rose: zRoseConfig.nullish(),
  roseParallel: zRoseParallelConfig.nullish(),
  pie: zPieConfig.nullish(),
  donut: zDonutConfig.nullish(),
  radar: zRadarConfig.nullish(),

  // race
  raceBar: zRaceBarConfig.nullish(),
  raceColumn: zRaceColumnConfig.nullish(),
  raceScatter: zRaceScatterConfig.nullish(),
  raceLine: zRaceLineConfig.nullish(),
  racePie: zRacePieConfig.nullish(),
  raceDonut: zRaceDonutConfig.nullish(),

  // hierarchy
  treeMap: zTreeMapConfig.nullish(),
  sunburst: zSunburstConfig.nullish(),
  circlePacking: zCirclePackingConfig.nullish(),
  hierarchySankey: zHierarchySankeyConfig.nullish(),
  sankey: zSankeyConfig.nullish(),

  // other
  funnel: zFunnelConfig.nullish(),
  heatmap: zHeatmapConfig.nullish(),
  boxPlot: zBoxplotConfig.nullish(),
  histogram: zHistogramConfig.nullish(),
})
